var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Vue from 'vue';
import ToolBar from '../../parts/ToolBar.vue';
import { Environment } from "../../../lib/environment";
import DialogPin from '../../parts/PinDialog.vue';
import { PinCodeHelper, WalletsHelper } from "../../../lib/storage";
export default Vue.extend({
    components: { ToolBar, DialogPin },
    name: "WalletDelete",
    props: {
        id: String
    },
    data() {
        return {
            showPinDialog: false
        };
    },
    methods: {
        deleteWallet() {
            return __awaiter(this, void 0, void 0, function* () {
                yield WalletsHelper.delete(this.id);
                this.goBackSelect();
            });
        },
        goBackSelect() {
            if (Environment.isIos() && Environment.isInStandaloneMode()) {
                this.$router.push('/wallet/select');
            }
            else {
                this.$router.go(-2);
            }
        },
        goBackSettings() {
            if (Environment.isIos() && Environment.isInStandaloneMode()) {
                this.$router.push('/wallet/settings?id=' + this.id);
            }
            else {
                this.$router.go(-1);
            }
        }
    },
    mounted() {
        return __awaiter(this, void 0, void 0, function* () {
            if (yield PinCodeHelper.hasSavedCode()) {
                this.showPinDialog = true;
            }
        });
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pages/wallet/WalletDelete.vue
// module id = 636
// module chunks = 1